<template>
  <div class="modal fade flexbox" id="modal-amazon-expiration" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body text-center">
          <h3 class="text-danger body-title">Amazonとのデータ連携を行ってください</h3>
          <div v-if="this.amazonExpirationContext.length" class="box-context">
            <div v-for="(item, index) in amazonExpirationContext" :key="index">
              <div :class="item.classes">{{ item.text }}</div>
            </div>
          </div>
          <div>
            <button type="button" class="btn w-200" data-dismiss="modal">このまま利用する</button>
            <button type="button" class="btn btn-warning w-200" data-dismiss="modal" @click.prevent="handleClick()">設定画面に移動する</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    amazonExpirationContext: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    handleClick () {
      this.$router.push('/warehouse-amazon/amazon-info')
    }
  },
  mounted () {
    $('#modal-amazon-expiration').modal('show')
    $('#modal-amazon-expiration').on('hidden.bs.modal', (e) => {
      $('body').attr({
        style: 'padding-right: 0px !important'
      })
    })
    $('#modal-amazon-expiration').on('shown.bs.modal', (e) => {
      $('body').attr({
        style: 'padding-right: 0px !important; overflow: hidden !important'
      })
    })
  },
  beforeDestroy () {
    $('#modal-amazon-expiration').modal('hide')
    $('.modal-backdrop').remove()
    localStorage.setItem('isShowModalAmazonExpiration', '')
  }
}
</script>

<style scoped>
#modal-amazon-expiration button {
  width: 180px;
  padding: 10px;
  margin-right: 30px;
  border-radius: 10px;
}
.body-title {
  margin: 0;
  font-size: 23px;
  font-weight: bold;
}
.box-context {
  margin-bottom: 50px;
}
.font-weight-normal {
  font-weight: normal;
}
#modal-amazon-expiration .modal-body {
  padding: 30px 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ModalAmazonExpiration.vue